import { IDelegateResponder, IDelegateConstant, IDelegateController } from 'ui-ng-delegate';

export interface IPhxPromptDelegate {
  handle(restrictTo: string): IPhxPromptDelegate;
  restrictTo(restrictTo: string): IPhxPromptDelegate;
  showPrompt: (configuration?: any) => void;
  hidePrompt: () => void;
}

class PhxPromptDelegate {
  constructor(DelegateController: IDelegateController, phxPromptConfiguration: IDelegateConstant) {
    DelegateController(this, phxPromptConfiguration);
  }
}

angular
  .module('capability-ng-global')
  .service('phxPromptDelegate', PhxPromptDelegate)
  .constant('phxPromptConfiguration', {
    uniqueComponent: 'phx-prompt',
    vocabulary: {
      showPrompt: (
        scope: any,
        element: ng.IAugmentedJQuery,
        attrs: ng.IAttributes,
        event: ng.IAngularEvent,
        configuration?: any
      ): void => {
        scope.isActive = true;
      },
      hidePrompt: (scope: any, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, event: ng.IAngularEvent): void => {
        scope.isActive = false;
      }
    }
  })
  .directive('phxPrompt', function(
    phxPromptDelegate: any,
    DelegateResponder: IDelegateResponder,
    phxPromptConfiguration: IDelegateConstant
  ): ng.IDirective {
    return {
      restrict: 'E',
      transclude: true,
      replace: false,
      template: '<div ng-if="isActive" ng-transclude></div>',
      scope: {},
      link: DelegateResponder(phxPromptConfiguration, function(scope, element, attrs) {
        scope.isActive = false;
      })
    };
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/phx_prompt/phx_prompt.ts